import React from 'react';
import { BarChartIcon, TrendingDownIcon, ClockIcon } from 'lucide-react';
export const OperationsEconomy = ({
  selectedScenario,
  formatPrice
}) => {
  const economyData = {
    good: {
      energySavingKwh: 4200,
      energySavingDkk: 8400,
      co2Reduction: 840,
      payback: 5.2
    },
    better: {
      energySavingKwh: 5800,
      energySavingDkk: 11600,
      co2Reduction: 1160,
      payback: 4.3
    },
    best: {
      energySavingKwh: 7500,
      energySavingDkk: 15000,
      co2Reduction: 1500,
      payback: 3.8
    }
  };
  const data = economyData[selectedScenario];
  return <section className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-37">
      <div className="p-6" data-id="element-38">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-39">
          Drift & økonomi (TCO/ROI)
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-40">
          <div className="bg-gray-50 rounded-lg p-4" data-id="element-41">
            <div className="flex items-center gap-3 mb-2" data-id="element-42">
              <BarChartIcon className="h-5 w-5 text-green-500" data-id="element-43" />
              <h3 className="font-medium text-gray-900" data-id="element-44">Energibesparelse</h3>
            </div>
            <p className="text-2xl font-bold text-gray-900" data-id="element-45">
              {data.energySavingKwh.toLocaleString('da-DK')} kWh
            </p>
            <p className="text-sm text-gray-500" data-id="element-46">
              Ca. {formatPrice(data.energySavingDkk)}/år
            </p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4" data-id="element-47">
            <div className="flex items-center gap-3 mb-2" data-id="element-48">
              <TrendingDownIcon className="h-5 w-5 text-blue-500" data-id="element-49" />
              <h3 className="font-medium text-gray-900" data-id="element-50">CO₂-estimat</h3>
            </div>
            <p className="text-2xl font-bold text-gray-900" data-id="element-51">
              {data.co2Reduction.toLocaleString('da-DK')} kg
            </p>
            <p className="text-sm text-gray-500" data-id="element-52">Reduktion per år</p>
          </div>
          <div className="bg-gray-50 rounded-lg p-4" data-id="element-53">
            <div className="flex items-center gap-3 mb-2" data-id="element-54">
              <ClockIcon className="h-5 w-5 text-purple-500" data-id="element-55" />
              <h3 className="font-medium text-gray-900" data-id="element-56">Payback</h3>
            </div>
            <p className="text-2xl font-bold text-gray-900" data-id="element-57">
              {data.payback.toLocaleString('da-DK')} år
            </p>
            <p className="text-sm text-gray-500" data-id="element-58">Tilbagebetalingstid</p>
          </div>
        </div>
        <div data-id="element-59">
          <h3 className="font-medium text-gray-900 mb-3" data-id="element-60">
            5-års totalomkostning
          </h3>
          <div className="relative h-24 bg-gray-100 rounded-lg overflow-hidden" data-id="element-61">
            <div className="absolute inset-0 flex items-end" data-id="element-62">
              <div className="w-1/3 h-16 bg-blue-400 flex items-center justify-center text-white font-medium" data-id="element-63">
                GOOD
              </div>
              <div className="w-1/3 h-20 bg-blue-500 flex items-center justify-center text-white font-medium" data-id="element-64">
                BETTER
              </div>
              <div className="w-1/3 h-24 bg-blue-600 flex items-center justify-center text-white font-medium" data-id="element-65">
                BEST
              </div>
            </div>
          </div>
          <div className="flex justify-between mt-2 text-xs text-gray-500" data-id="element-66">
            <span data-id="element-67">Lavere initialomkostning</span>
            <span data-id="element-68">Bedre TCO over tid</span>
          </div>
        </div>
      </div>
    </section>;
};